// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}
.wo-loading {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-radius: 6px;
  font-size: 0.82rem;
  background: #fafafa;
  border: 1px solid #ededed;
  color: #171717;
}
.wo-error {
  padding: 10px 14px;
  border-radius: 6px;
  background: #fef2f2;
  border: 1px solid rgba(220, 38, 38, 0.2);
  color: #dc2626;
  font-size: 0.82rem;
}
.wo-alert {
  padding: 8px 12px;
  border-radius: 6px;
  background: #fef2f2;
  border: 1px solid rgba(220, 38, 38, 0.15);
  color: #dc2626;
  font-size: 0.8rem;
  margin-bottom: 12px;
}
.wo-busy {
  font-size: 0.78rem;
  color: #a3a3a3;
  margin-bottom: 8px;
}
.wo-panel {
  max-width: 100%;
}
.wo-section {
  margin-bottom: 16px;
}
.wo-section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}
.wo-section-icon {
  font-size: 1rem;
  line-height: 1;
}
.wo-section-title {
  margin: 0;
  font-size: 0.82rem;
  font-weight: 700;
  color: #171717;
  flex: 1;
}
.wo-total {
  font-size: 1rem;
  font-weight: 800;
  color: #16a34a;
  white-space: nowrap;
}
.wo-empty {
  font-size: 0.8rem;
  color: #a3a3a3;
  font-style: italic;
  padding: 8px 0;
}
.wo-cards {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.wo-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 12px;
  background: #fff;
  border: 1px solid #ededed;
  transition: border-color 120ms ease, box-shadow 120ms ease, transform 120ms ease;
}
.wo-card:hover {
  border-color: #a3a3a3;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transform: translateY(-1px);
}
.wo-card-include {
  border-left: 4px solid #16a34a;
}
.wo-card-exclude {
  border-left: 4px solid #dc2626;
  background: #fefafa;
}
.wo-card-body {
  flex: 1;
  min-width: 0;
}
.wo-card-source {
  font-size: 0.88rem;
  font-weight: 700;
  color: #171717;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.wo-card-meta {
  font-size: 0.72rem;
  color: #a3a3a3;
  margin-top: 2px;
}
.wo-card-reason {
  margin-top: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  color: #dc2626;
}
.wo-card-amount {
  flex-shrink: 0;
  text-align: right;
}
.wo-amount-main {
  font-size: 1.15rem;
  font-weight: 800;
  color: #16a34a;
  line-height: 1.1;
}
.wo-amount-sub {
  font-size: 0.6rem;
  font-weight: 600;
  text-transform: uppercase;
  color: #a3a3a3;
}
.wo-card-actions {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}
.wo-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: 1px solid #ededed;
  background: #fafafa;
  cursor: pointer;
  font-size: 0.85rem;
  transition: background 120ms ease, border-color 120ms ease, transform 120ms ease;
}
.wo-action-btn:hover:not(:disabled) {
  background: #f5f5f5;
  border-color: #a3a3a3;
  transform: scale(1.08);
}
.wo-action-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.wo-action-danger:hover:not(:disabled) {
  background: #fef2f2;
  border-color: rgba(220, 38, 38, 0.3);
}
.wo-action-flag:hover:not(:disabled) {
  background: #fffbeb;
  border-color: rgba(234, 136, 12, 0.3);
}
.wo-finding-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 12px;
  margin-top: 8px;
  border-radius: 8px;
  background: #fffbeb;
  border: 1px solid rgba(234, 136, 12, 0.2);
}
.wo-finding-header {
  font-size: 0.82rem;
  font-weight: 700;
  color: #ea580c;
}
.wo-finding-actions {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
}
.wo-finding-error {
  font-size: 0.75rem;
  color: #dc2626;
}
.wo-confirm {
  padding-top: 12px;
  border-top: 1px solid #ededed;
}
.wo-confirm-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  min-height: 48px;
  padding: 10px 20px;
  border-radius: 12px;
  border: none;
  font-size: 0.92rem;
  font-weight: 700;
  color: #fff;
  background: #005ff0;
  cursor: pointer;
  transition: background 120ms ease, transform 120ms ease, box-shadow 120ms ease;
}
.wo-confirm-btn:hover:not(:disabled) {
  background: #004fc7;
  transform: translateY(-1px);
  box-shadow: 0 4px 14px rgba(0, 95, 240, 0.2);
}
.wo-confirm-btn:focus {
  outline: 2px solid rgba(0, 95, 240, 0.3);
  outline-offset: 2px;
}
.wo-confirm-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}
.wo-confirm-btn {
  border-radius: 999px;
  padding-left: 1rem;
  padding-right: 1rem;
  font-weight: 600;
}
.wo-edit-mode {
  margin-bottom: 12px;
}
.wo-edit-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ededed;
}
.wo-edit-title {
  font-size: 0.88rem;
  font-weight: 700;
  color: #171717;
}
.wo-edit-cancel {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 5px 14px;
  border-radius: 999px;
  border: 1px solid #ededed;
  background: #fff;
  font-size: 0.78rem;
  font-weight: 600;
  color: #005ff0;
  cursor: pointer;
  transition: background 120ms ease, border-color 120ms ease;
}
.wo-edit-cancel:hover:not(:disabled) {
  background: #fafafa;
  border-color: #005ff0;
}
.wo-edit-cancel:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.wo-confirm-hint {
  text-align: center;
  font-size: 0.72rem;
  color: #a3a3a3;
  margin-top: 6px;
}
.wo-confirm-icon {
  font-size: 1.1rem;
}
.wo-card-notes {
  margin-top: 2px;
  font-size: 0.72rem;
  color: #a3a3a3;
  font-style: italic;
}
.wo-finalizing {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}
.wo-finalizing-spinner {
  position: relative;
  width: 64px;
  height: 64px;
  margin-bottom: 20px;
}
.wo-spinner-ring {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: #005ff0;
  animation: wo-spin 1.2s linear infinite;
}
.wo-ring-2 {
  inset: 6px;
  border-top-color: #16a34a;
  animation-duration: 0.9s;
  animation-direction: reverse;
}
.wo-ring-3 {
  inset: 12px;
  border-top-color: #5d4d80;
  animation-duration: 1.5s;
}
@keyframes wo-spin {
  to {
    transform: rotate(360deg);
  }
}
.wo-finalizing-text {
  font-size: 1.1rem;
  font-weight: 700;
  color: #171717;
  margin-bottom: 4px;
}
.wo-finalizing-sub {
  font-size: 0.82rem;
  color: #a3a3a3;
}
.wo-celebrate {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 50px 20px;
  text-align: center;
}
.wo-celebrate-icon {
  font-size: 3.5rem;
  line-height: 1;
  margin-bottom: 12px;
  animation: wo-bounce 0.6s ease 0.3s both;
}
@keyframes wo-bounce {
  0% {
    transform: scale(0.8);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
.wo-celebrate-title {
  font-size: 1.5rem;
  font-weight: 800;
  color: #16a34a;
  margin-bottom: 8px;
}
.wo-celebrate-amount {
  font-size: 2rem;
  font-weight: 800;
  color: #171717;
  line-height: 1.1;
}
.wo-celebrate-per {
  font-size: 0.9rem;
  font-weight: 600;
  color: #a3a3a3;
}
.wo-celebrate-detail {
  font-size: 0.82rem;
  color: #a3a3a3;
  margin-top: 8px;
}
.wo-celebrate-saving {
  font-size: 1rem;
  font-weight: 700;
  color: #16a34a;
  margin-top: 20px;
  padding: 8px 20px;
  background: rgba(22, 163, 74, 0.08);
  border-radius: 999px;
  display: inline-block;
  animation: wo-fade-in 0.6s ease 0.8s both, wo-pulse-green 2s ease-in-out 1.4s infinite;
}
@keyframes wo-pulse-green {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
}
.wo-ellipsis::after {
  content: '';
  animation: wo-dots 1.4s steps(4, end) infinite;
}
@keyframes wo-dots {
  0% {
    content: '';
  }
  25% {
    content: '.';
  }
  50% {
    content: '..';
  }
  75% {
    content: '...';
  }
  100% {
    content: '';
  }
}
@keyframes wo-fade-in {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.wo-busy {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.78rem;
  color: #a3a3a3;
  margin-bottom: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/app/screening-module/income-wizard/phases/wizard-overview-phase.component.less"],"names":[],"mappings":"AAaA;EACE,cAAA;AAZF;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;AAdF;AAiBA;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,wCAAA;EACA,cAAA;EACA,kBAAA;AAfF;AAkBA;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yCAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;AAhBF;AAmBA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;AAjBF;AAqBA;EACE,eAAA;AAnBF;AAuBA;EACE,mBAAA;AArBF;AAwBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AAtBF;AAyBA;EACE,eAAA;EACA,cAAA;AAvBF;AA0BA;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,OAAA;AAxBF;AA2BA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAzBF;AA4BA;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;AA1BF;AA8BA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA5BF;AA+BA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,gFAAA;AA7BF;AA+BE;EACE,qBAAA;EACA,yCAAA;EACA,2BAAA;AA7BJ;AAiCA;EACE,8BAAA;AA/BF;AAkCA;EACE,8BAAA;EACA,mBAAA;AAhCF;AAmCA;EACE,OAAA;EACA,YAAA;AAjCF;AAoCA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAlCF;AAqCA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;AAnCF;AAsCA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AApCF;AAuCA;EACE,cAAA;EACA,iBAAA;AArCF;AAwCA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAtCF;AAyCA;EACE,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;AAvCF;AA2CA;EACE,aAAA;EACA,QAAA;EACA,cAAA;AAzCF;AA4CA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gFAAA;AA1CF;AA4CE;EACE,mBAAA;EACA,qBAAA;EACA,sBAAA;AA1CJ;AA6CE;EACE,YAAA;EACA,mBAAA;AA3CJ;AAgDE;EACE,mBAAA;EACA,oCAAA;AA9CJ;AAmDE;EACE,mBAAA;EACA,qCAAA;AAjDJ;AAsDA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,yCAAA;AApDF;AAuDA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AArDF;AAwDA;EACE,aAAA;EACA,yBAAA;EACA,QAAA;AAtDF;AAyDA;EACE,kBAAA;EACA,cAAA;AAvDF;AA2DA;EACE,iBAAA;EACA,6BAAA;AAzDF;AA4DA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,8EAAA;AA1DF;AA4DE;EACE,mBAAA;EACA,2BAAA;EACA,4CAAA;AA1DJ;AA6DE;EACE,wCAAA;EACA,mBAAA;AA3DJ;AA8DE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AA5DJ;AAgEA;EACE,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AA9DF;AAkEA;EACE,mBAAA;AAhEF;AAmEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;AAjEF;AAoEA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AAlEF;AAqEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,0DAAA;AAnEF;AAqEE;EACE,mBAAA;EACA,qBAAA;AAnEJ;AAsEE;EAAa,aAAA;EAAe,mBAAA;AAlE9B;AAsEA;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AApEF;AAuEA;EACE,iBAAA;AArEF;AAyEA;EACE,eAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AAvEF;AA2EA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AAzEF;AA4EA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AA1EF;AA6EA;EACE,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,uCAAA;AA3EF;AA8EA;EACE,UAAA;EACA,yBAAA;EACA,wBAAA;EACA,4BAAA;AA5EF;AA+EA;EACE,WAAA;EACA,yBAAA;EACA,wBAAA;AA7EF;AAgFA;EACE;IAAK,yBAAA;EA7EL;AACF;AA+EA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AA7EF;AAgFA;EACE,kBAAA;EACA,cAAA;AA9EF;AAkFA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AAhFF;AAmFA;EACE,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,wCAAA;AAjFF;AAoFA;EACE;IAAK,qBAAA;EAjFL;EAkFA;IAAM,qBAAA;EA/EN;EAgFA;IAAO,mBAAA;EA7EP;AACF;AA+EA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AA7EF;AAgFA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AA9EF;AAiFA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AA/EF;AAkFA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;AAhFF;AAmFA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,mCAAA;EACA,oBAAA;EACA,qBAAA;EACA,sFAAA;AAjFF;AAoFA;EACE;;IAAW,UAAA;EAhFX;EAiFA;IAAM,YAAA;EA9EN;AACF;AAgFA;EACE,WAAA;EACA,8CAAA;AA9EF;AAiFA;EACE;IAAK,WAAA;EA9EL;EA+EA;IAAM,YAAA;EA5EN;EA6EA;IAAM,aAAA;EA1EN;EA2EA;IAAM,cAAA;EAxEN;EAyEA;IAAO,WAAA;EAtEP;AACF;AAwEA;EACE;IAAO,UAAA;IAAY,0BAAA;EApEnB;EAqEA;IAAK,UAAA;IAAY,wBAAA;EAjEjB;AACF;AAoEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AAlEF","sourcesContent":["// UDS-inspired tokens\n@uds-blue-70: #005ff0;\n@uds-green-70: #16a34a;\n@uds-red-70: #dc2626;\n@uds-neutral-10: #fafafa;\n@uds-neutral-20: #f5f5f5;\n@uds-neutral-30: #ededed;\n@uds-neutral-50: #a3a3a3;\n@uds-neutral-100: #171717;\n@uds-radius: 12px;\n@uds-radius-sm: 6px;\n@uds-ease: 120ms ease;\n\n:host {\n  display: block;\n}\n\n// ── Loading / Error ──\n.wo-loading {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 14px;\n  border-radius: @uds-radius-sm;\n  font-size: 0.82rem;\n  background: @uds-neutral-10;\n  border: 1px solid @uds-neutral-30;\n  color: @uds-neutral-100;\n}\n\n.wo-error {\n  padding: 10px 14px;\n  border-radius: @uds-radius-sm;\n  background: #fef2f2;\n  border: 1px solid rgba(220, 38, 38, 0.2);\n  color: @uds-red-70;\n  font-size: 0.82rem;\n}\n\n.wo-alert {\n  padding: 8px 12px;\n  border-radius: @uds-radius-sm;\n  background: #fef2f2;\n  border: 1px solid rgba(220, 38, 38, 0.15);\n  color: @uds-red-70;\n  font-size: 0.8rem;\n  margin-bottom: 12px;\n}\n\n.wo-busy {\n  font-size: 0.78rem;\n  color: @uds-neutral-50;\n  margin-bottom: 8px;\n}\n\n// ── Panel ──\n.wo-panel {\n  max-width: 100%;\n}\n\n// ── Section ──\n.wo-section {\n  margin-bottom: 16px;\n}\n\n.wo-section-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.wo-section-icon {\n  font-size: 1rem;\n  line-height: 1;\n}\n\n.wo-section-title {\n  margin: 0;\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: @uds-neutral-100;\n  flex: 1;\n}\n\n.wo-total {\n  font-size: 1rem;\n  font-weight: 800;\n  color: @uds-green-70;\n  white-space: nowrap;\n}\n\n.wo-empty {\n  font-size: 0.8rem;\n  color: @uds-neutral-50;\n  font-style: italic;\n  padding: 8px 0;\n}\n\n// ── Cards layout ──\n.wo-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.wo-card {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  border-radius: @uds-radius;\n  background: #fff;\n  border: 1px solid @uds-neutral-30;\n  transition: border-color @uds-ease, box-shadow @uds-ease, transform @uds-ease;\n\n  &:hover {\n    border-color: @uds-neutral-50;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n    transform: translateY(-1px);\n  }\n}\n\n.wo-card-include {\n  border-left: 4px solid @uds-green-70;\n}\n\n.wo-card-exclude {\n  border-left: 4px solid @uds-red-70;\n  background: #fefafa;\n}\n\n.wo-card-body {\n  flex: 1;\n  min-width: 0;\n}\n\n.wo-card-source {\n  font-size: 0.88rem;\n  font-weight: 700;\n  color: @uds-neutral-100;\n  line-height: 1.3;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.wo-card-meta {\n  font-size: 0.72rem;\n  color: @uds-neutral-50;\n  margin-top: 2px;\n}\n\n.wo-card-reason {\n  margin-top: 4px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: @uds-red-70;\n}\n\n.wo-card-amount {\n  flex-shrink: 0;\n  text-align: right;\n}\n\n.wo-amount-main {\n  font-size: 1.15rem;\n  font-weight: 800;\n  color: @uds-green-70;\n  line-height: 1.1;\n}\n\n.wo-amount-sub {\n  font-size: 0.6rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: @uds-neutral-50;\n}\n\n// ── Action buttons ──\n.wo-card-actions {\n  display: flex;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.wo-action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  border: 1px solid @uds-neutral-30;\n  background: @uds-neutral-10;\n  cursor: pointer;\n  font-size: 0.85rem;\n  transition: background @uds-ease, border-color @uds-ease, transform @uds-ease;\n\n  &:hover:not(:disabled) {\n    background: @uds-neutral-20;\n    border-color: @uds-neutral-50;\n    transform: scale(1.08);\n  }\n\n  &:disabled {\n    opacity: 0.4;\n    cursor: not-allowed;\n  }\n}\n\n.wo-action-danger {\n  &:hover:not(:disabled) {\n    background: #fef2f2;\n    border-color: rgba(220, 38, 38, 0.3);\n  }\n}\n\n.wo-action-flag {\n  &:hover:not(:disabled) {\n    background: #fffbeb;\n    border-color: rgba(234, 136, 12, 0.3);\n  }\n}\n\n// ── Finding form ──\n.wo-finding-form {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 10px 12px;\n  margin-top: 8px;\n  border-radius: 8px;\n  background: #fffbeb;\n  border: 1px solid rgba(234, 136, 12, 0.2);\n}\n\n.wo-finding-header {\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: #ea580c;\n}\n\n.wo-finding-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 6px;\n}\n\n.wo-finding-error {\n  font-size: 0.75rem;\n  color: #dc2626;\n}\n\n// ── Confirm footer ──\n.wo-confirm {\n  padding-top: 12px;\n  border-top: 1px solid @uds-neutral-30;\n}\n\n.wo-confirm-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  min-height: 48px;\n  padding: 10px 20px;\n  border-radius: @uds-radius;\n  border: none;\n  font-size: 0.92rem;\n  font-weight: 700;\n  color: #fff;\n  background: @uds-blue-70;\n  cursor: pointer;\n  transition: background @uds-ease, transform @uds-ease, box-shadow @uds-ease;\n\n  &:hover:not(:disabled) {\n    background: darken(@uds-blue-70, 8%);\n    transform: translateY(-1px);\n    box-shadow: 0 4px 14px rgba(0, 95, 240, 0.2);\n  }\n\n  &:focus {\n    outline: 2px solid rgba(0, 95, 240, 0.3);\n    outline-offset: 2px;\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n    transform: none;\n    box-shadow: none;\n  }\n}\n\n.wo-confirm-btn {\n  border-radius: 999px;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  font-weight: 600;\n}\n\n// ── Inline edit mode ──\n.wo-edit-mode {\n  margin-bottom: 12px;\n}\n\n.wo-edit-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 12px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid @uds-neutral-30;\n}\n\n.wo-edit-title {\n  font-size: 0.88rem;\n  font-weight: 700;\n  color: @uds-neutral-100;\n}\n\n.wo-edit-cancel {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 5px 14px;\n  border-radius: 999px;\n  border: 1px solid @uds-neutral-30;\n  background: #fff;\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: @uds-blue-70;\n  cursor: pointer;\n  transition: background @uds-ease, border-color @uds-ease;\n\n  &:hover:not(:disabled) {\n    background: @uds-neutral-10;\n    border-color: @uds-blue-70;\n  }\n\n  &:disabled { opacity: 0.45; cursor: not-allowed; }\n}\n\n// ── Confirm hint ──\n.wo-confirm-hint {\n  text-align: center;\n  font-size: 0.72rem;\n  color: @uds-neutral-50;\n  margin-top: 6px;\n}\n\n.wo-confirm-icon {\n  font-size: 1.1rem;\n}\n\n// ── Card notes ──\n.wo-card-notes {\n  margin-top: 2px;\n  font-size: 0.72rem;\n  color: @uds-neutral-50;\n  font-style: italic;\n}\n\n// ── Finalizing overlay ──\n.wo-finalizing {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  text-align: center;\n}\n\n.wo-finalizing-spinner {\n  position: relative;\n  width: 64px;\n  height: 64px;\n  margin-bottom: 20px;\n}\n\n.wo-spinner-ring {\n  position: absolute;\n  inset: 0;\n  border-radius: 50%;\n  border: 3px solid transparent;\n  border-top-color: @uds-blue-70;\n  animation: wo-spin 1.2s linear infinite;\n}\n\n.wo-ring-2 {\n  inset: 6px;\n  border-top-color: @uds-green-70;\n  animation-duration: 0.9s;\n  animation-direction: reverse;\n}\n\n.wo-ring-3 {\n  inset: 12px;\n  border-top-color: #5d4d80;\n  animation-duration: 1.5s;\n}\n\n@keyframes wo-spin {\n  to { transform: rotate(360deg); }\n}\n\n.wo-finalizing-text {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: @uds-neutral-100;\n  margin-bottom: 4px;\n}\n\n.wo-finalizing-sub {\n  font-size: 0.82rem;\n  color: @uds-neutral-50;\n}\n\n// ── Celebration ──\n.wo-celebrate {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 50px 20px;\n  text-align: center;\n}\n\n.wo-celebrate-icon {\n  font-size: 3.5rem;\n  line-height: 1;\n  margin-bottom: 12px;\n  animation: wo-bounce 0.6s ease 0.3s both;\n}\n\n@keyframes wo-bounce {\n  0% { transform: scale(0.8); }\n  50% { transform: scale(1.2); }\n  100% { transform: scale(1); }\n}\n\n.wo-celebrate-title {\n  font-size: 1.5rem;\n  font-weight: 800;\n  color: @uds-green-70;\n  margin-bottom: 8px;\n}\n\n.wo-celebrate-amount {\n  font-size: 2rem;\n  font-weight: 800;\n  color: @uds-neutral-100;\n  line-height: 1.1;\n}\n\n.wo-celebrate-per {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: @uds-neutral-50;\n}\n\n.wo-celebrate-detail {\n  font-size: 0.82rem;\n  color: @uds-neutral-50;\n  margin-top: 8px;\n}\n\n.wo-celebrate-saving {\n  font-size: 1rem;\n  font-weight: 700;\n  color: @uds-green-70;\n  margin-top: 20px;\n  padding: 8px 20px;\n  background: rgba(22, 163, 74, 0.08);\n  border-radius: 999px;\n  display: inline-block;\n  animation: wo-fade-in 0.6s ease 0.8s both, wo-pulse-green 2s ease-in-out 1.4s infinite;\n}\n\n@keyframes wo-pulse-green {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.6; }\n}\n\n.wo-ellipsis::after {\n  content: '';\n  animation: wo-dots 1.4s steps(4, end) infinite;\n}\n\n@keyframes wo-dots {\n  0% { content: ''; }\n  25% { content: '.'; }\n  50% { content: '..'; }\n  75% { content: '...'; }\n  100% { content: ''; }\n}\n\n@keyframes wo-fade-in {\n  from { opacity: 0; transform: translateY(6px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n// ── Busy state ──\n.wo-busy {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.78rem;\n  color: @uds-neutral-50;\n  margin-bottom: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
